import { useTranslation } from "react-i18next";
import React, { useMemo, useState } from 'react';
import { contactMetadata, groupsMetadata, propertyOrder } from 'Modules/ContactModule';
import CardProperty from 'Components/Personal/CardProperty';
import CardPreview from 'Components/Personal/CardPreview';
import './OneCard.css'; // import { deleteCard, testIt } from '../../Actions/PersonalActions'

export default function OneCard({
  profile,
  cardId,
  profileLoading
}) {
  const {
    t
  } = useTranslation();
  // Create a comprehensive list of all available properties for manage Cards
  const allAvailableProperties = useMemo(() => {
    if (!profile || !profile.properties) return []; // Get user ID from existing properties

    const idProp = profile.properties.find(p => p && p.objectId && p.objectId.includes('_'));
    const userId = idProp && idProp.objectId ? idProp.objectId.split('_')[1] : 'default'; // Group all available properties by their group

    const grouped = {}; // Get all properties from contactMetadata

    Object.keys(contactMetadata).forEach(propertyName => {
      const metadata = contactMetadata[propertyName];
      const groupName = metadata.group;

      if (!grouped[groupName]) {
        const groupMeta = groupsMetadata[groupName];
        grouped[groupName] = { ...groupMeta,
          properties: []
        };
      } // Check if this property exists in the profile


      const existingProperty = profile.properties.find(p => p && p.name === propertyName);

      if (existingProperty) {
        // Property exists in backend - use the real property
        if (existingProperty.multiple && existingProperty.values) {
          // Handle multiple properties (like emailAddresses)
          existingProperty.values.forEach(value => {
            if (!value) return; // Add this line

            grouped[groupName].properties.push({ ...existingProperty,
              ...value,
              value: value.parameters && value.parameters['1'] ? value.parameters['1'].value : value.value,
              objectId: value.objectId,
              verified: value.verified,
              createdAt: value.createdAt,
              updatedAt: value.updatedAt,
              parameters: value.parameters,
              ...metadata,
              showName: metadata.showName
            });
          });
        } else {
          // Handle single properties
          grouped[groupName].properties.push({ ...existingProperty,
            ...metadata,
            showName: metadata.showName
          });
        }
      } else {
        // Property doesn't exist in backend - create a placeholder
        grouped[groupName].properties.push({
          name: propertyName,
          value: '',
          objectId: `${propertyName}_${userId}`,
          verified: false,
          createdAt: new Date(),
          updatedAt: new Date(),
          ...metadata,
          showName: metadata.showName
        });
      }
    }); // Sort properties within each group by propertyOrder

    Object.keys(grouped).forEach(groupName => {
      const order = propertyOrder[groupName] || [];

      if (order.length > 0) {
        grouped[groupName].properties.sort((a, b) => {
          const indexA = order.indexOf(a.name);
          const indexB = order.indexOf(b.name); // Properties not in order array go to the end

          if (indexA === -1 && indexB === -1) return 0;
          if (indexA === -1) return 1;
          if (indexB === -1) return -1;
          return indexA - indexB;
        });
      }
    }); // Convert to array and sort by order

    return Object.values(grouped).filter(group => group.properties.length > 0) // Only show groups with properties
    .sort((a, b) => a.order - b.order);
  }, [profile]);
  const card = useMemo(() => {
    if (!profile || !profile.cards) return null;
    let foundCard = profile.cards.find(c => c && (c.objectId || c.id) === cardId); // Map short Work card ID to canonical Work card ID if properties are empty or missing

    if ((!foundCard || !foundCard.properties || foundCard.properties.length === 0) && cardId === 'E8BUJEjh9m') {
      const canonicalCard = profile.cards.find(c => c && c.objectId === 'card_work_KY5WuKOFkj');
      if (canonicalCard) foundCard = canonicalCard;
    }

    console.log('OneCard card found:', foundCard);
    console.log('OneCard card properties:', foundCard && foundCard.properties ? foundCard.properties.map(p => p ? {
      name: p.name,
      objectId: p.objectId
    } : null) : null);
    return foundCard;
  }, [profile, cardId]);
  const [expandedGroup, setExpandedGroup] = useState(0); // Handle missing card

  if (!card) {
    return <div>{t("Card not found")}</div>;
  }

  return <div className="modern-cards-page">
            <div className="cards-container">
                {
        /* Properties Management Section */
      }
                <div className="properties-section glass-panel">


                    <div className="properties-grid">
                        {allAvailableProperties.map((group, groupIndex) => {
            const isExpanded = expandedGroup === groupIndex;
            return <div key={`${group.showName || group.name || 'group'}-${groupIndex}`} className={`property-group-card ${isExpanded ? 'expanded' : ''}`}>
                                    <div className="group-header" onClick={() => setExpandedGroup(isExpanded ? null : groupIndex)} style={{
                cursor: 'pointer'
              }}>
                                        <div style={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: '10px'
                }}>
                                            <span style={{
                    transform: isExpanded ? 'rotate(90deg)' : 'rotate(0deg)',
                    transition: 'transform 0.2s',
                    fontSize: '12px',
                    color: '#666'
                  }}>▶</span>
                                            <h3 className="group-title" style={{
                    fontSize: '0.8rem'
                  }}>{t(group.showName)}</h3>
                                        </div>
                                        <div className="group-count" style={{
                  fontSize: '0.6rem',
                  padding: '2px 8px'
                }}>{group.properties.length} {t("properties")}</div>
                                    </div>

                                    {isExpanded && <div className="properties-list">
                                            {group.properties.map((property, index) => {
                  // Ensure we always have a valid key (never empty string)
                  const objectIdStr = property.objectId != null ? typeof property.objectId === 'string' ? property.objectId.trim() : String(property.objectId) : '';
                  const idStr = property.id != null ? typeof property.id === 'string' ? property.id.trim() : String(property.id) : '';
                  const propertyKey = objectIdStr !== '' ? objectIdStr : idStr !== '' ? idStr : `${property.name || 'property'}-${groupIndex}-${index}`;
                  return <div key={propertyKey} className="property-item">
                                                        <CardProperty propertyMeta={property} card={card} />
                                                    </div>;
                })}
                                        </div>}
                                </div>;
          })}
                    </div>
                </div>

                {
        /* Card Preview Section */
      }
                <div className="preview-section">


                    <div className="preview-container">
                        <CardPreview key={`${card.id}-${card.properties ? card.properties.length : 0}-${card.properties ? card.properties.map(p => p ? p.objectId : '').join(',') : ''}`} card={card} profile={profile} profileLoading={profileLoading} />
                    </div>
                </div>
            </div>
        </div>;
}